export default __webpack_public_path__ + "static/media/arisan_logo_m.8023edb4.svg";